import { useRef } from "react";
import { Tooltip } from "frontend/ui-components/floaters/tooltip";
import { useHover } from "usehooks-ts";

export function RequiredFieldMark({
  tooltipLabel = "required field",
  customStyle,
}: {
  tooltipLabel?: string;
  customStyle?: React.CSSProperties;
}) {
  const requiredFieldRef = useRef<HTMLSpanElement>(null);
  const requiredFieldHover = useHover(requiredFieldRef);

  return (
    <>
      <span ref={requiredFieldRef} style={{ color: "#F9746A" }}>
        {" "}
        *
      </span>
      {requiredFieldHover && (
        <Tooltip
          label={tooltipLabel}
          relativeTo={requiredFieldRef}
          side="bottom"
          customStyle={{
            backgroundColor: "#AFB3BF",
            color: "#113357",
            textAlign: "center",
            fontFamily: "Poppins",
            fontSize: "10px",
            fontStyle: "normal",
            fontWeight: "400",
            lineHeight: "14px",
            borderRadius: "6px",
            ...customStyle,
          }}
        />
      )}
    </>
  );
}
